import { createActions, createReducer } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedArea } from 'contracts/Areas';

const { Types, Creators } = createActions(
  {
    request: ['warehouseId', 'areaIds', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage', 'validationErrors'],
    reset: [],
  },
  { prefix: 'UPDATE_WAREHOUSE_AREAS_' }
);

export interface UpdateWarehouseAreasRequestAction {
  warehouseId: number | string;
  areaIds: number[];
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface State {
  data: ListedArea[];
  loading: boolean;
  errorMessage: string | null;
}

const INITIAL_STATE: State = { data: [], loading: false, errorMessage: null };

export const updateWarehouseAreas = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: (state: State) =>
    update(state, {
      loading: { $set: true },
      errorMessage: { $set: null },
    }),
  [Types.SUCCESS]: (state: State, action: { data: ListedArea[] }) =>
    update(state, {
      data: { $set: action.data },
      loading: { $set: false },
    }),
  [Types.FAILURE]: (state: State, action: { errorMessage: string }) =>
    update(state, {
      loading: { $set: false },
      errorMessage: { $set: action.errorMessage },
    }),
  [Types.RESET]: () => INITIAL_STATE,
});

export const UpdateWarehouseAreasTypes = Types;
export const UpdateWarehouseAreasActions = Creators;
